<div data-testid="hr-tool-selection">
  @if (providerGroups().length === 0) {
    <app-no-data />
  } @else {
    <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      @for (group of providerGroups(); track group.id) {
        <button
          type="button"
          class="hr-provider-tile card relative aspect-square bg-second-level"
          (click)="openProvider(group)"
          [attr.data-testid]="'hr-provider-tile-' + group.id"
        >
          <span class="absolute left-2 top-2 flex gap-1.5 text-muted-color">
            @for (type of group.applicationTypes; track type) {
              <i [class]="applicationTypeIcon(type)" [title]="applicationTypeLabel(type)"></i>
            }
          </span>

          <span class="flex h-full items-center justify-center p-4 pt-7">
            @if (showLogo(group)) {
              <img
                [src]="group.logoUrl"
                [alt]="group.name"
                class="max-h-[55%] max-w-[60%] object-contain"
                (error)="onLogoError(group)"
              />
            } @else {
              <span class="text-center text-sm font-semibold text-muted-color">
                {{ group.name }}
              </span>
            }
          </span>

          <span
            class="hr-provider-tile__label absolute bottom-0 left-0 right-0 truncate px-3 py-2 text-xs font-semibold"
          >
            {{ group.name }}
          </span>
        </button>
      }
    </div>
  }
</div>

<app-hr-tool-provider-modal [group]="selectedGroup()" [(visible)]="modalVisible" />
